/**
 * RTWO Genesis — Runtime finalized state cache for sync readiness surfaces.
 */

let runtimeGenesisFinalized = false;
let runtimeGenesisBlockHash: string | null = null;

export function publishRuntimeGenesisFinalizedState(input: {
  finalized: boolean;
  genesisBlockHash?: string | null;
}): void {
  runtimeGenesisFinalized = input.finalized;
  runtimeGenesisBlockHash = input.genesisBlockHash ?? null;
}

export function isRuntimeGenesisFinalized(): boolean {
  return runtimeGenesisFinalized;
}

export function getRuntimeGenesisBlockHash(): string | null {
  return runtimeGenesisBlockHash;
}

export function resetRuntimeGenesisFinalizedCacheForTests(): void {
  runtimeGenesisFinalized = false;
  runtimeGenesisBlockHash = null;
}
